import { APP_INITIALIZER, EnvironmentProviders, ErrorHandler, InjectionToken, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular';
import { APP_CONFIG, IAppSettings } from '../config/interfaces/iapp-settings.interface';
import { MonitoringConfig } from './monitoring-config.interface';
import { MonitoringService } from './monitoring.service';

export const MONITORING_CONFIG = new InjectionToken<MonitoringConfig>('monitoring-config');

export function provideMonitoring(config: MonitoringConfig): EnvironmentProviders {
	return makeEnvironmentProviders([
		importProvidersFrom(ApmModule),
		ApmService,
		{
			provide: ErrorHandler,
			useClass: ApmErrorHandler
		},
		{
			provide: MONITORING_CONFIG,
			useValue: config
		},
		{
			provide: APP_INITIALIZER,
			multi: true,
			useFactory: (monitoringConfig: MonitoringConfig, monitoringService: MonitoringService, config: IAppSettings) => {
				return async () => {
					monitoringService.init(monitoringConfig.name);
				};
			},
			deps: [MONITORING_CONFIG, MonitoringService, APP_CONFIG]
		}
	]);
}
